/**
 * jsonから取得した表示のために必要なデータ。
 */
const jsonData = {
  namespaced: true,
  state: {
    tables: {
      // bigan_names: {
      //   // example -> "01": "化粧水 ・ ローション"
      // },
      // brand_names: {},
      // seibun: {},
      // kinou_code: {},
      // kaori: {},
      // yakuji_kubun: {},
      // worries_some: {},
      // price_range: {
      //   // example) "01": [0, 5000],
      // },
      // kinou_search: {},
    },
    forms: {
      // bigan_names: {
      //   // example) "bigan_names_01": {"label": "化粧水 ・ ローション","values": ["01"], "scid": "keshosui" },
      // },
      // brand_names: {},
      // seibun: {},
      // worries_some: {},
      // price_range: {},
      // kinou_search: {},
    },
  },
  mutations: {
    setTables(state, value) {
      state.tables = value;
    },
    setForms(state, value) {
      state.forms = value;
    },
  },
  actions: {
    setTables: ({ commit }, value) => {
      commit("setTables", value);
    },
    setForms: ({ commit }, value) => {
      commit("setForms", value);
    },
  },
  getters: {
    tables: (state) => state.tables,
    forms: (state) => state.forms,
    getTableData: (state) => (key) => {
      return state.tables[key];
    },
    getFormData: (state) => (key) => {
      return state.forms[key];
    },
  },
};

export default jsonData;
